module.exports = __webpack_public_path__ + "static/media/templates-admin.9c4f453d.svg";